import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"white-space":"pre-wrap"} }


import { useI18n } from 'vue-i18n';
import LKFModal from '@/components/LKFModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DataProtection',
  props: {
    isOpen: { type: Boolean }
  },
  setup(__props: any) {

const { t } = useI18n();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LKFModal, {
    style: {"pointer-events":"auto"},
    "is-open": _ctx.isOpen,
    title: _unref(t)('cookie-bar.data-protection-title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('cookie-bar.data-protection-content')), 1)
    ]),
    _: 1
  }, 8, ["is-open", "title"]))
}
}

})